<div class="box_loader d-flex justify-content-center align-items-center">
  <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
</div>
